module.exports = __webpack_public_path__ + "img/Display.fb95fd28.png";